import { AppRoutes } from "@/routes/config";

type StepLink = {
  label: string;
  url: string;
};

type StepItem = {
  title: string;
  content: string[];
  links: StepLink[];
};

export const STEPS_TUTORIAL: StepItem[] = [
  {
    title: "登録支援機関情報の登録",
    content: ["登録支援機関の基本情報を登録しましょう。"],
    links: [{ label: "登録支援機関情報の編集へ", url: AppRoutes.rsoEdit }],
  },
  {
    title: "外国人と受験計画の登録",
    content: [
      "試験計画を立てたい外国人を登録しましょう。",
      "外国人を登録したのち、試験計画を立て、学習アプリのアカウントを発行することができます。"
    ],
    links: [{ label: "外国人の登録へ", url: AppRoutes.learnerCreate }],
  },
  {
    title: "ユーザー設定の入力",
    content: ["アカウント設定、メール配信設定ができます。この設定は任意です。"],
    links: [{ label: "ユーザー設定へ", url: AppRoutes.userSettingEdit }],
  },
  {
    title: "初期設定完了",
    content: [
      "お疲れ様でした。ご不明な点等ございましたら、チャットからお問い合わせください。",
      "これら表示が不要であれば、「このチュートリアルを閉じる」を押してください。",
    ],
    links: [],
  },
];
